// @ts-nocheck
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { AddCartLinesApiParameter } from "@insite/client-framework/Services/CartService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/AddCartLines";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { replaceInChain } from "@toolkit/Modules/client-framework/HandlerCreator";

replaceInChain(chain, PopulateApiParameter, props => {
    const cartLineCollection: CartLineModel[] = [];
    props.parameter.productInfos.forEach(o => {
        cartLineCollection.push({
            productId: o.productId,
            qtyOrdered: o.qtyOrdered,
            unitOfMeasure: o.unitOfMeasure,
            // Store Custom Code
            properties: { artSelection: o.selectedArtId },
        } as unknown as CartLineModel);
    });

    cartLineCollection.forEach(line => {
        const parsedQty = line.qtyOrdered ? parseFloat(line.qtyOrdered.toString()) : 1;
        line.qtyOrdered = parsedQty > 0 ? parsedQty : 1;
    });

    props.apiParameter = {
        cartLineCollection: {
            cartLines: cartLineCollection,
        },
        cartId: API_URL_CURRENT_FRAGMENT,
    } as AddCartLinesApiParameter;
});
